import { login } from "@/api/user";
import { getToken, setToken, removeToken, getName, setName, removeName } from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
    token: getToken(),
    name: getName()
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    }
};

const actions = {
    login({ commit }, userInfo) {
        const { userName, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ userName, password })
                .then((response) => {
                    const { data } = response;
                    if (data) {
                        let temp = data.user;
                        commit("SET_NAME", temp.username);
                        setName(temp.username);
                        commit("SET_TOKEN", temp.id);
                        setToken(temp.id);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    // 统一认证登录
    authLogin({ commit }) {
        return new Promise((resolve, reject) => {
            try {
                const token = sessionStorage.getItem("Authorization") || "";
                const userInfoStr = sessionStorage.getItem("client-userInfo");
                const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
                const username = userInfo.cn || "";

                const data = {
                    id: token,
                    username
                };

                if (data.id || data.username) {
                    commit("SET_TOKEN", data.id);
                    commit("SET_NAME", data.username);
                    setToken(data.id);
                    setName(data.username);
                }

                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    resetToken({ commit }) {
        return new Promise((resolve) => {
            commit("SET_TOKEN", "");
            commit("SET_NAME", "");
            removeToken();
            removeName();
            sessionStorage.removeItem("client-userInfo");
            sessionStorage.removeItem("Authorization");
            sessionStorage.clear();
            localStorage.clear();
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
